<template>
  <div class="modal fade" tabindex="-1" id="renewSignatureModal" ref="modal"  aria-labelledby="renewSignatureModal"
       aria-hidden="true"
       data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5 text-center">Verificação de assinatura digital.</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  @click="hideModalRenewSignature"></button>
        </div>
        <div class="modal-body">
          <h1 class="text-center">
            <i class="bi bi-pen"></i>
          </h1>
          <h6>
            É necessário realizar uma nova verificação da sua assinatura digital. Por favor, insira o seu PIN de
            Certificação Digital no campo abaixos.
          </h6>
          <input type="text" class="rounded-input" v-model="pin" placeholder="Digite aqui o seu PIN"
                 @input="validateInput('pin', $event)" maxlength="6" :disabled="isLoading">
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="hideModalRenewSignature">
            Fechar janela
          </button>
          <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span role="status"> Carregando...</span>
          </button>
          <button v-else class="btn btn-primary" @click="validToken" :disabled="isLoading">
            Renovar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import {Modal} from "bootstrap";

export default {
  props: {
    visibleModalSignatureRequired: Boolean,
  },
  computed: {
    ...mapGetters({
      Report: "StateReport",
      User: "StateUser",
      UrlReport: "StateUrlReport"
    }),
  },
  data() {
    return {
      pin: null,
      isLoading: false
    };
  },
  async mounted() {
    this.isLoading = false;
  },
  methods: {
    ...mapGetters(["isAuthenticated"]),
    ...mapActions(["SendPin"]),
    hideModalRenewSignature() {
      this.$emit("close")
      this.$emit("hideModalRenewSignature")
    },
    validateInput(fieldName, event) {
      const regex = /\D/g;
      const correctedValue = event.target.value.replace(regex, '');
      event.target.value = correctedValue
      this[fieldName] = correctedValue;
    },
    async validToken() {
      try {
        if (this.pin == null || this.pin == '' || this.pin.length < 6) {
          this.$toast.error('Preencha o PIN - 6 dígitos numéricos.', {
            timeout: 3000,
            closeOnClick: true
          });
        } else {
          this.isLoading = true;
          await this.SendPin(this.pin)
          this.$toast.success('Pin Atualizado.', {
            timeout: 3000,
            closeOnClick: true
          });
          this.$emit('reloadPage');
          this.isLoading = false;
        }
      } catch (erro) {
        if (erro.message === '400') {
          this.$toast.warning('Pin Incorreto.', {
            timeout: 3000,
            closeOnClick: true
          });
          this.isLoading = false;
        } else {
          this.$toast.error('Ocorreu um erro, tente novamente.', {
            timeout: 3000,
            closeOnClick: true
          });
          this.isLoading = false;
        }
      }
    },
    show() {
      const modal = new Modal(this.$refs.modal, {})
      modal.show()
    }
  },
};
</script>

<style>
.rounded-input {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 16px;
  width: 300px;
  outline: none;
}
</style>
